// client/src/pages/gallery/GalleryDataSetsList.js
import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context";

export default function GalleryDataSetsList() {
  const navigate = useNavigate();
  const { activeOrgId, activeOrg } = useOrg();
  const [tableKey, setTableKey] = useState(0);

  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  // force reload on org change
  useEffect(() => setTableKey((k) => k + 1), [orgId]);

  // ---------------------------
  // columns (aligned style)
  // ---------------------------
  const columns = useMemo(
    () => [
      { label: "", type: "count", value: "__count", width: "48px", align: "center" },

      {
        label: "Name",
        value: "name",
        search: "name",
        width: "240px"
      },

      {
        label: "Dataset",
        value: "datasetId",
        width: "240px",
        type: "render",
        render: (row) => row?.datasetId || ""
      },

      {
        label: "Updated",
        value: "updatedAt",
        width: "180px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : "")
      }
    ],
    []
  );

  // ---------------------------
  // buttons (aligned with your system)
  // ---------------------------
  const buttons = [
    {
      label: "View",
      class: "btn-blue",
      action: "/gallery/display/{_id}"
    },
    {
      label: "Edit",
      class: "btn-green",
      action: "/gallery/setup/{_id}"
    },
    {
      label: "Copy",
      class: "btn-gray",
      requestPath: "/gallery/settings/copy/{_id}",
      requestMethod: "POST"
    },
    {
      label: "Delete",
      class: "btn-danger",
      action: "delete"
    }
  ];

  // ---------------------------
  // UI
  // ---------------------------
  return (
    <div className="datatable-page">
      <div
        className="datatable-header-row"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
          Gallery Configurations
        </div>
      </div>

      <SmartDataTable
        key={`gallery-${orgId}-${tableKey}`}
        config={{
          columns,

          // 🔥 THIS IS THE KEY CHANGE
          queryName: `/gallery/settings?orgId=${orgId}`,

          pageSize: 20,
          buttons,

          deletePathTemplate: "/gallery/settings/delete/{_id}", // make sure backend exists
          deleteMethod: "POST",

          headerActions: (
            <>
              <button
                className="btn-green add-new-button"
                onClick={() => navigate("/gallery/setup/new")}
              >
                Add New Gallery
              </button>
            </>
          )
        }}
      />
    </div>
  );
}
